const Interests = [
  {
    title: "Climbing",
    content: "I know I mentioned it above, but let it be known that this is a telling interest of mine. "
  },
  {
    title: "Steak and Sushi",
    content: "Nothing sounds better than a cast iron seared rib eye basted with butter and a fresh, marbelized cut of fatty tuna."
  },
  {
    title: "Pour Over Coffee",
    content: "The only way to drink coffee black. Acidic, fruity notes are my 💩."
  },
  {
    title: "Shredding the Gnar",
    content: "There's just something about deep carves in knee deep powder that is so euphoric."
  },
  {
    title: "Photography",
    content: "Unfortunately not as involved as I'd like to be, but I still appreciate @andrewkearns-esque photos."
  },
  {
    title: "Puns",
    content: "/r/dadjokes is my second home."
  }
];

export default Interests;



// WEBPACK FOOTER //
// ./src/data/interests.js